import React from 'react';
import PropTypes from 'prop-types';
import PatientForm from '../../../components/Patients/Form/PatientForm';

const actionTypes = {
  edit: 'EDIT',
};

const Patient = props => (
  <PatientForm
    {...props}
    actionType={actionTypes.edit}
    canEditPatients={props.canEditPatients}
    updatePatientIsActiveStatus={props.updatePatientIsActiveStatus}
  />
);

Patient.propTypes = {
  canEditPatients: PropTypes.bool.isRequired,
};

export default Patient;
